import { ShieldCheck, Lock, Shield, CheckCircle2, BadgeCheck, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

export default function PrivacyPolicy() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3, duration: 0.5 }}
      whileHover={{ y: -3 }}
      className="relative bg-white/90 backdrop-blur-sm p-6 rounded-2xl border border-gray-100 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden"
    >
      {/* Decorative security gradient */}
      <div className="absolute -right-10 -top-10 w-32 h-32 rounded-full bg-green-100/40 filter blur-xl -z-0" />

      <div className="relative z-10">
        <div className="flex items-center gap-3 mb-6">
          <div className="p-2 rounded-lg bg-green-50 border border-green-100 shadow-sm">
            <ShieldCheck className="w-5 h-5 text-green-600" />
          </div>
          <h3 className="text-xl font-bold bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text text-transparent">
            Data Protection & Privacy
          </h3>
        </div>

        <div className="space-y-4 text-sm text-gray-600 leading-relaxed">
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="p-4 bg-green-50/50 rounded-lg border border-green-100"
          >
            <Lock className="w-4 h-4 inline mr-2 text-green-500" />
            At Adspace-Tech, privacy is a priority. All advertiser, publisher, and user data is securely encrypted and never sold or misused.
          </motion.p>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
            className="p-4 bg-blue-50/50 rounded-lg border border-blue-100"
          >
            <Shield className="w-4 h-4 inline mr-2 text-blue-500" />
            We follow strict compliance standards including GDPR, CCPA, and IAB’s TCF framework. Your data is protected at every step of the ad delivery pipeline.
          </motion.p>

          <motion.ul
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
            className="grid grid-cols-1 md:grid-cols-2 gap-3"
          >
            {[
              "Data is anonymized before analytics processing",
              "No selling of personal or behavioral data to third parties",
              "Compliance with GDPR, CCPA, and global data laws",
              "All servers hosted in secure ISO-certified data centers",
              "Consent-based data collection via IAB TCF v2.2",
              "End-to-end encryption for all API and dashboard traffic",
              "Users can request full data export or deletion anytime"
            ].map((item, index) => (
              <motion.li
                key={index}
                initial={{ opacity: 0, x: -10 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.7 + index * 0.05 }}
                className="flex items-start p-3 rounded-lg hover:bg-gray-50/50 transition-colors"
              >
                <CheckCircle2 className="w-4 h-4 mt-0.5 mr-2 text-green-500 flex-shrink-0" />
                <span>{item}</span>
              </motion.li>
            ))}
          </motion.ul>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1 }}
          className="mt-6 pt-4 border-t border-gray-100 flex flex-wrap justify-between items-center gap-3"
        >
          <div className="flex items-center text-xs text-gray-500">
            <BadgeCheck className="w-4 h-4 mr-1 text-green-500" />
            Last updated: {new Date().toLocaleDateString()}
          </div>
          <button className="text-sm font-medium text-green-600 hover:text-green-800 flex items-center transition-colors group">
            Read full policy
            <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
          </button>
        </motion.div>
      </div>
    </motion.div>
  );
}
